import styled, {css, keyframes} from 'styled-components'

const strokeAnimation = keyframes`
    to {stroke-dashoffset: 0;}
`

export const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin: ${({margin}) => margin}; 

    >svg {
        >circle {
            stroke-width: ${({strokeWidth}) => strokeWidth};
            stroke: ${({theme, strokeColor}) => strokeColor ?? theme.primary};
            animation: none;

            ${({isReloading}) => !isReloading && css`
                :last-child {
                    stroke-dasharray: ${({size}) => 2 * 3.14 * ((size/2)-2)};
                    stroke-dashoffset: ${({size}) => 2 * 3.14 * ((size/2)-2)};
                    stroke: ${({theme}) => theme.button.secondary.text};
                    stroke-width: ${({strokeWidth}) => strokeWidth};
                    animation: ${strokeAnimation} ${({duration}) => `${duration}s`} linear;
                }
            `}
        }
    }
`

export const Label = styled.p`
    position: absolute;
`